import React from 'react';
import classnames from 'classnames';
import { TextButton } from 'scy/buttons';
import ChevronLeft from 'images/icons/controls/chevron-left.svg?react-svg';
import ChevronRight from 'images/icons/controls/chevron-right.svg?react-svg';
import { flex, wrap, centerItems, centerContent } from 'scy/flex.mod.scss';
import { plainList } from 'scy/utils.mod.scss';
import styles from './Pagination.mod.scss';

export default function ReviewsPagination({
  pageCount,
  currentPage,
  loadPage,
  disabled
}) {
  if (pageCount < 1) return null;

  return (
    <ol
      className={classnames(plainList, flex, wrap, centerItems, centerContent)}
    >
      <li className={styles.arrowLeft}>
        <TextButton
          noUnderline
          onClick={() => loadPage(currentPage - 1)}
          className={styles.button}
          disabled={disabled || currentPage <= 0}
        >
          <ChevronLeft width={6} height={10} />
        </TextButton>
      </li>

      {Array(pageCount)
        .fill(null)
        .map((_, idx) => {
          const isCurrentPage = currentPage === idx;
          return (
            <li
              key={idx}
              className={classnames(styles.pageLink, {
                [styles.selectedPageLink]: isCurrentPage,
                [styles.disabledSelectedPageLink]: disabled && isCurrentPage
              })}
            >
              <TextButton
                noUnderline
                onClick={() => loadPage(idx)}
                className={styles.button}
                disabled={disabled}
              >
                {idx + 1}
              </TextButton>
            </li>
          );
        })}

      <li className={styles.arrowRight}>
        <TextButton
          noUnderline
          onClick={() => loadPage(currentPage + 1)}
          className={styles.button}
          disabled={disabled || currentPage >= pageCount - 1}
        >
          <ChevronRight width={6} height={10} />
        </TextButton>
      </li>
    </ol>
  );
}
